import React from 'react'
import BackgroundImage from '../../assets/jpeg/banner-hero.jpeg'
import { Box, Button, Typography } from '@mui/material'
import AnimatedHeadline from '../submodules/AnimatedHeadline'

const BannerHero = (props) => {

  const widthForBackgroundColor = props?.width <= 890 ? "100%" : "50%"
  const headlineSize = props?.width < 1365 ? 50 : 80
  const responsiveHeight = props?.width < 1365 ? 110 : 250
  const responsiveTextCenter = props?.width < 1400 ? "center" : "left"

  return (
    <Box
      component="div"
      width="100%"
      height="90vh"
      sx={{
        backgroundImage: `url(${BackgroundImage})`,
        backgroundPosition: "50% 50%",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Box sx={{alignItems: "center", background: "linear-gradient(90deg, white, rgba(255,255,255,0.4) 85%, transparent 100%)", display: "flex", justifyContent: "center", height: "100%", width: widthForBackgroundColor,}}>
        <Box sx={{ textAlign: responsiveTextCenter,}}>
          <Typography component="h1" variant="h1" fontSize={40} fontWeight={600}>
            The perfect tool to
          </Typography>
          <Box sx={{height: responsiveHeight, width: 400,}}>
            <AnimatedHeadline responsiveSize={headlineSize} />
          </Box>
          <Button href="#contact-us" variant="contained" color="secondary">
            Get Started
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default BannerHero